import styled from 'styled-components'

export const LoadingContainer = styled.div`
  //   margin: auto;
`

export const LoaderEl = styled.div``
